import { render, staticRenderFns } from "./RegionForm.vue?vue&type=template&id=3d4e9fbf"
import script from "./RegionForm.vue?vue&type=script&lang=js"
export * from "./RegionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports